module.exports = __webpack_public_path__ + "img/italy-ovarian-cancer-female.ded54304.png";